import { MarketingShell } from "@/components/landing/MarketingShell";
import { useSession } from "@/components/useSession";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { LandingPage2 } from "@/components/landing2";

function Page() {
  const router = useRouter();
  const { status } = useSession();
  const [stay, setStay] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setStay(window.document.location.hash === "#stay");
    }
  }, []);

  if (stay === false) {
    if (status === "authenticated") {
      router.push("/dashboard", undefined, { shallow: true });
      return;
    }
  }

  return (
    <MarketingShell className="flex flex-col justify-center">
      <LandingPage2 />
    </MarketingShell>
  );
}

export default Page;
